import api from "utils/api";

const BASE = "/buccl_user/api/v1/freediving-pb";

// 프리다이빙 종목 정의 — BE issue #142 spec
export const PB_DISCIPLINES = [
    { code: "CWT", label: "CWT", unit: "m", type: "meters" },
    { code: "CNF", label: "CNF", unit: "m", type: "meters" },
    { code: "FIM", label: "FIM", unit: "m", type: "meters" },
    { code: "DYN", label: "DYN", unit: "m", type: "meters" },
    { code: "DNF", label: "DNF", unit: "m", type: "meters" },
    { code: "STA", label: "STA", unit: "", type: "seconds" },
];

export const isSecondsDiscipline = (code) => code === "STA";

// 최고 기록 조회 (본인 또는 타인)
export const getBestPb = async (userId) => {
    try {
        const params = userId ? { user_id: userId } : {};
        const res = await api.get(`${BASE}/best/`, { params });
        return res.data?.best_records ?? [];
    } catch (err) {
        console.error("PB best 조회 오류:", err);
        return [];
    }
};

// 이력 전체 조회 (강사용)
export const listPbHistory = async (userId) => {
    try {
        const params = userId ? { user_id: userId } : {};
        const res = await api.get(`${BASE}/`, { params });
        return res.data ?? [];
    } catch (err) {
        console.error("PB 이력 조회 오류:", err);
        return [];
    }
};

// 강사 PB 등록
export const createPb = async (payload) => {
    const res = await api.post(`${BASE}/`, payload);
    return res.data;
};

// 강사 PB 수정
export const updatePb = async (id, payload) => {
    const res = await api.patch(`${BASE}/${id}/`, payload);
    return res.data;
};

// 강사 PB 삭제
export const deletePb = async (id) => {
    const res = await api.delete(`${BASE}/${id}/`);
    return res.data;
};
